const getItem = ({ itemName }) => {
  let itemValue;
  if (itemName) {
    itemValue = sessionStorage.getItem(itemName);
  }
  return itemValue;
};

const setItem = ({ itemName, value }) => {
  if (itemName) {
    sessionStorage.setItem(itemName, value);
  }
};

const removeItem = ({ itemName }) => {
  if (itemName) {
    sessionStorage.removeItem(itemName);
  }
};

const sessionStorageService = { getItem, setItem, removeItem };

export default sessionStorageService;
